import React from 'react';
import CustomScrollbars from 'util/CustomScrollbars';
import Navigation from "../../components/Navigation";

const SideBarContent = () => {
    const navigationMenus = [
        {
            name: 'sidebar.inBuiltApp',
            type: 'section',
            children: [
                {
                    name: 'sidebar.dashboard',
                    type: 'item',
                    icon: 'view-dashboard',
                    link: '/app/homepage/list'
                },
                 {
                    name: 'sidebar.dashboard.homes',
                    type: 'item',
                    icon: 'view-dashboard',
                    link: '/app/homes/list'
                },
                {
                    name: 'sidebar.dashboard.reserves',
                    type: 'item',
                    icon: 'view-dashboard',
                    link: '/app/reserves/list/0'
                },
                {
                    name: 'sidebar.dashboard.contacts',
                    type: 'item',
                    icon: 'view-dashboard',
                    link: '/app/reserves/contacts'
                },
                {
                    name: 'sidebar.dashboard.tasvies',
                    type: 'item',
                    icon: 'view-dashboard',
                     link: '/app/reserves/contactstasvie'
                    // link: '/app/map'
                    // link: '/app/eCommerce/products-list'
                },
                {
                    name: 'sidebar.dashboard.agent',
                    type: 'item',
                    icon: 'view-dashboard',
                     link: '/app/reserves/agentlist'
                    // link: '/app/map'
                    // link: '/app/eCommerce/products-list'
                },
                {
                    name: 'sidebar.dashboard.user',
                    type: 'item',
                    icon: 'view-dashboard',
                     link: '/app/signup'
                    // link: '/app/map'
                    // link: '/app/eCommerce/products-list'
                },

                {
                    name: 'sidebar.dashboard.customize',
                    type: 'item',
                    icon: 'view-dashboard',
                     link: '/app/customize'
                    // link: '/app/map'
                    // link: '/app/eCommerce/products-list'
                },
                {
                    name: 'sidebar.dashboard.sites',
                    type: 'item',
                    icon: 'view-dashboard',
                     link: '/app/connectsites'
                    // link: '/app/map'
                    // link: '/app/eCommerce/products-list'
                },

                // {
                //     name: 'sidebar.dashboard.report',
                //     type: 'item',
                //     icon: 'view-dashboard',
                //      link: '/app/reserves/report'
                //     // link: '/app/map'
                //     // link: '/app/eCommerce/products-list'
                // },
                // {
                //     name: 'sidebar.dashboard.connect',
                //     type: 'item',
                //     icon: 'view-dashboard',
                //      link: '/app/reserves/connect'
                //     // link: '/app/map'
                //     // link: '/app/eCommerce/products-list'
                // },
                {
                    name: 'sidebar.dashboard.ticket',
                    type: 'item',
                    icon: 'view-dashboard',
                     link: '/app/reserves/ticket'
                    // link: '/app/map'
                    // link: '/app/eCommerce/products-list'
                },
                {
                    name: 'sidebar.dashboard.install',
                    type: 'item',
                    icon: 'view-dashboard',
                     link: '/util/DialogClose3'
                    // link: '/app/map'
                    // link: '/app/eCommerce/products-list'
                },
                {
                    name: 'sidebar.dashboard.logout',
                    type: 'item',
                    icon: 'view-dashboard',
                     link: '/util/DialogClose2'
                    // link: '/app/map'
                    // link: '/app/eCommerce/products-list'
                }

                // ,
                // {
                //     name: 'sidebar.dashboard.logout',
                //     type: 'item',
                //     icon: 'view-dashboard',
                //     link: '/logout'
                // }



            ]
        },
    ];

    return (
        <CustomScrollbars className=" scrollbar">
            <Navigation menuItems={navigationMenus}/>
        </CustomScrollbars>
    );
};

export default SideBarContent;
